<template>
  <v-form v-model="valid" :class="!disable ? 'disable-events' : ''">
    <v-row
      v-for="(item, index) in rangeTime"
      :key="index"
      tag="div"
      style="margin: 0"
    >
      <v-col cols="4">
        <v-menu
          ref="menuTimeStart"
          v-model="item.menuTimeStart"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="tertiary--text text-body-2">
              Desde
            </div>
            <v-text-field
              :id="`idEventosRestriccionHorariaDesde${indexForDomElementIds}`"
              dense
              v-model="item.startTime"
              prepend-icon="mdi-clock-time-four-outline"
              :disabled="pickerDisabled"
              v-bind="attrs"
              hide-details="auto"
              :error-messages="errorMessages[index]"
              @input="
                checkTimeDifference(item, index, 'startTime', 'menuTimeStart')
              "
              color="tertiary"
              v-on="on"
              class="mr-4 align-center"
              :rules="rules"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="item.menuTimeStart"
            v-model="item.startTime"
            color="tertiary"
            no-title
            @click:minute="
              save(index, 'startTime', 'menuTimeStart', item.startTime)
            "
            :max="item.endTime | maxFilter"
          ></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="4">
        <v-menu
          ref="menuTimeEnd"
          v-model="item.menuTimeEnd"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="tertiary--text text-body-2">
              Hasta
            </div>
            <v-text-field
              :id="`idEventosRestriccionHorariaHasta${indexForDomElementIds}`"
              dense
              v-model="item.endTime"
              prepend-icon="mdi-clock-time-four-outline"
              :disabled="pickerDisabled"
              v-bind="attrs"
              hide-details="auto"
              :error-messages="errorMessages[index]"
              @input="
                checkTimeDifference(item, index, 'endTime', 'menuTimeEnd')
              "
              color="tertiary"
              v-on="on"
              class="mr-4 align-center"
              :rules="rules"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="item.menuTimeEnd"
            v-model="item.endTime"
            color="tertiary"
            no-title
            @click:minute="save(index, 'endTime', 'menuTimeEnd', item.endTime)"
            :min="item.startTime | minFilter"
          ></v-time-picker>
        </v-menu>
      </v-col>
      <v-col cols="4" v-if="disable" class="mt-5 pl-0">
        <div>
          <FmButton
            v-if="showIconDelete(index)"
            @click="removeRange(item.id)"
            :type="'close'"
            :button-text="'Eliminar'"
          />
          <div v-else></div>
        </div>
      </v-col>
      <v-col cols="8" v-if="disable">
        <div class="d-flex justify-center">
          <FmButton
            v-if="rangeTime.length - 1 == index"
            @click="addRange()"
            :button-text="
              $t('fleet_management.agents.create.labels.create_range_time')
            "
            :color="'tertiary'"
          />
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { i18n } from '@leapsight/portal'
import dayjs from 'dayjs'
import FmButton from '@/share/components/FmButton.vue'
export default {
  components: { FmButton },
  props: {
    idRestrictions: {
      type: String
    },
    edit: {
      type: Array
    },
    disable: {
      type: Boolean
    },
    indexForDomElementIds: {
      type: Number
    }
  },
  data() {
    return {
      rules: [
        value =>
          !!value ||
          i18n.t('fleet_management.agents.create.errors.field_required'),
        value =>
          /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(value) ||
          i18n.t(
            'fleet_management.agents.create.errors.time_range_format_error'
          )
      ],
      pickerDisabled: false,
      idRangeHours: 'idRangeHours' + new Date().getTime(),
      rangeTime: [
        {
          id: null,
          menuTimeEnd: false,
          endTime: null,
          menuTimeStart: false,
          startTime: null
        }
      ],
      errorMessages: []
    }
  },
  filters: {
    maxFilter: function(val) {
      if (val) {
        const dateEnd = val.split(':')
        const time = dayjs()
          .hour(dateEnd[0])
          .minute(`${parseInt(dateEnd[1]) - 1}`)
          .format('HH:mm')
        return time
      }
      return val
    },
    minFilter: function(val) {
      if (val) {
        const dateEnd = val.split(':')
        const time = dayjs()
          .hour(dateEnd[0])
          .minute(`${parseInt(dateEnd[1]) + 1}`)
          .format('HH:mm')
        return time
      }
    }
  },
  methods: {
    showIconDelete(index) {
      const lengthRange = this.rangeTime.length
      let result = false
      if (lengthRange > 1) {
        result = true
      } else {
        result = false
      }

      return result
    },
    checkTimeDifference(item, index, type, typeMenu) {
      if (
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.startTime) &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.endTime) &&
        item.startTime > item.endTime
      ) {
        this.errorMessages[index] = i18n.t(
          'fleet_management.agents.create.errors.time_range_difference_error'
        )
      } else {
        this.errorMessages[index] = ''
      }
      const hours = type === 'startTime' ? item.startTime : item.endTime
      const rangeIsValid =
        item.endTime != null &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.startTime) &&
        /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(item.endTime) &&
        item.startTime <= item.endTime
      if (rangeIsValid) {
        this.save(index, type, typeMenu, hours)
      }
    },
    save(index, type, typeMenu, hours) {
      this.rangeTime[index][type] = hours
      this.rangeTime[index][typeMenu] = false
      this.$emit('hoursRange', {
        range: this.rangeTime,
        id: this.idRestrictions
      })
    },
    addRange() {
      const uniq = 'idRange' + new Date().getTime()
      const newRangeTime = {
        id: null,
        menuTimeEnd: false,
        endTime: null,
        menuTimeStart: false,
        startTime: null
      }
      newRangeTime.id = uniq
      this.rangeTime.push(newRangeTime)
    },
    removeRange(id) {
      const index = this.rangeTime.findIndex(e => e.id === id)
      this.errorMessages.splice(index, 1)
      this.rangeTime = this.rangeTime.filter(e => e.id != id)
      this.$emit('hoursRange', {
        range: this.rangeTime,
        id: this.idRestrictions
      })
    }
  },
  watch: {
    rangeTime: {
      handler(val) {
        const valid = val.every(
          e =>
            e.endTime != null &&
            /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(e.startTime) &&
            /^([0-1][0-9]|2[0-3]):[0-5][0-9]$/gm.test(e.endTime) &&
            e.startTime <= e.endTime
        )
        this.$emit('emitValidRange', valid)
      },
      deep: true
    }
  },
  mounted() {
    this.rangeTime[0].id = 'idRange' + new Date().getTime()
    if (!this.disable) this.rangeTime = this.edit
  }
}
</script>

<style></style>
